import { render, staticRenderFns } from "./SettingRootIconPopup.vue?vue&type=template&id=1a03ee8e&scoped=true"
import script from "./SettingRootIconPopup.vue?vue&type=script&lang=js"
export * from "./SettingRootIconPopup.vue?vue&type=script&lang=js"
import style0 from "./SettingRootIconPopup.vue?vue&type=style&index=0&id=1a03ee8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a03ee8e",
  null
  
)

export default component.exports